<div class="natureza-juridica-form-control">
    <label class="col-form-label">
        {{label}}
    </label>
    <div class="input-group">                        
        <div class="input-group-prepend">
            <span class="input-group-text">
                {{codigo}}
            </span>
        </div>
        <input type="text" class="form-control" [value]="nome ? nome : ''" disabled="disabled" readonly="readonly">                                                                                                        
    </div>
    <p class="form-text text-muted">
        {{helpText}}
    </p>    
</div>